import React from 'react';

// Pure record fields only: do not synthesize a workbench decision for a reader.
export default function ReadOnlyRecordDetails({ record }) {
    const fields = [
        ['Status', 'estadoConcilia'], ['Date', 'goFecha', 'pfFecha'],
        ['Vendor', 'goProveedor', 'satNombreEmisor'], ['NIT', 'goProveedorID', 'satNitEmisor'],
        ['Amount', 'goMonto', 'pfMonto', 'satGranTotal'], ['Currency', 'satMoneda'],
        ['Series', 'goSerieID'], ['Number', 'goNumeroID'],
        ['Reference', 'pfReferencia'], ['Description', 'pfDescripcion']
    ];
    const get = key => record?.[key] ?? record?.[key[0].toUpperCase() + key.slice(1)];
    return <>
        <p className="text-muted">Read-only record. Operational decisions require Execute access.</p>
        <dl>{fields.map(([label, ...keys]) => {
            const value = keys.map(get).find(item => item !== undefined && item !== null);
            return value === undefined ? null : <React.Fragment key={label}><dt>{label}</dt><dd>{String(value)}</dd></React.Fragment>;
        })}</dl>
    </>;
}
